import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import SquareLocationImporterWidget, { generateList } from '../../container/VenueImporterView/SquareLocationImporterWidget';
import { ISquareLocationItem } from '../../container/VenueImporterView/SquareLocationItem';
import { IReduxAppState } from "../../reducers";
import { VenueSelectionDialog } from "../modal/VenueSelectionDialog";
import { setDialogHandle } from "../../actions/dialog";
import { setVenueData } from "../../yoello-lib/modules/redux/actions/venue.actions";

import { ISearchableChecklistItem } from '../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem';
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';
import { useHistory } from 'react-router-dom';


const VenueImporterDialog = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const history = useHistory();

    const { callAPI, isError } = useAPIV2(APIExtensions.createVenues, {
        onMountDisabled: true,
    });

    const selectedVenueId = useSelector(
        (state: IReduxAppState) => state.selectedVenueId
    );

    const returnToVenueList = (items: ISquareLocationItem[]) => {
        items.forEach((item: any) => {
            dispatch(setVenueData('venueData', item.id, item));
        })
        dispatch(
            setDialogHandle({
                Component: VenueSelectionDialog,
                ComponentProps: {
                    history
                },
                dialogTitle: t("venueSelection.title"),
                isFormDialog:false
            })
        )
    }

    const venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData);
    const [ isLoading, setIsLoading ] = useState(true);
    const [ locations, setLocations ] = useState<ISearchableChecklistItem[]>([]);    

    useEffect(() => {
        callAPI(HTTPMethods.GET, {
            query: `?venue_id=${venue?.id}`,
        }).then((response: any) => {
            setIsLoading(false);
            setLocations(generateList(response.data.locations));
         }).catch((error: Error) => {
             setIsLoading(false);
         });
         //eslint-disable-next-line
    }, [])

    return (
        <SquareLocationImporterWidget 
            locations={locations}
            loading={isLoading}
            error={isError}
            onSuccess={returnToVenueList}
        />
    )
}


export default VenueImporterDialog;